import { Pipe, PipeTransform } from '@angular/core';

import { TimeService } from '../shared/services/time.service';


export class TimezoneOffsetPipe implements PipeTransform {

	constructor(private timeService: TimeService) { }

	public transform(timezone: string, args?: any[]): string {
		if (typeof this.timeService.mappedTimezonesWithOffset[timezone] !== 'undefined') {
			return timezone + ' (GMT ' + this.timeService.mappedTimezonesWithOffset[timezone].offset + ')';
		}

		return timezone;
	}
static ctorParameters() { return [ { type: TimeService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/pipes/timezone-offset.pipe.ts